import React, { Component } from 'react';
import { HashRouter as Router, Route } from "react-router-dom";
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import axios from 'axios';

import Header from './components/Header';
import Landing from './components/Landing';
import Mapa from './components/Mapa';

import './css/App.css';

// ************ Fontawesome ************
import { library } from '@fortawesome/fontawesome-svg-core';
import { faBars } from '@fortawesome/free-solid-svg-icons';
library.add(faBars);
// ************ Fontawesome ************

// Material theme
const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  palette: {
    primary: {
      main: '#002e6d'
    },
    secondary: {
      main: '#48c7f4'
    },
    error: {
      main: '#ec5968'
    }
  },
});
// Material 

let url = "https://geopoint.host/administrador/api/";
// let url = "https://geopoint.host/develop/administrador/api/";
let w = window.location.hostname.substring(0, 3);
if (w === "www") {
  url = "https://www.geopoint.host/administrador/api/";
  // url = "https://www.geopoint.host/develop/administrador/api/";
}

class App extends Component {
  constructor(props) {
    super(props);
    this.changeLogged = this.changeLogged.bind(this);
    this.changeMapType = this.changeMapType.bind(this);
    this.toggleLTE = this.toggleLTE.bind(this);
    this.toggleFTTH = this.toggleFTTH.bind(this);
    this.toggleAdquirida = this.toggleAdquirida.bind(this);
    this.toggleHFC = this.toggleHFC.bind(this);
    this.toggleSearch = this.toggleSearch.bind(this);
    this.toggleRegions = this.toggleRegions.bind(this);
    this.toggleRegionsMenu = this.toggleRegionsMenu.bind(this);
    this.toggleInitialModal = this.toggleInitialModal.bind(this);
    this.toggleSearchNodo = this.toggleSearchNodo.bind(this);
    this.toggleSearchPoste = this.toggleSearchPoste.bind(this);
    this.changeFCoordinates = this.changeFCoordinates.bind(this);
    this.toggleSearchCoordenadas = this.toggleSearchCoordenadas.bind(this);
    this.loadNodos = this.loadNodos.bind(this);

    this.getLocation = this.getLocation.bind(this);
    this.showPosition = this.showPosition.bind(this);
    this.loadPolygons = this.loadPolygons.bind(this);
    this.updateLoaded = this.updateLoaded.bind(this);
    this.updateSearch = this.updateSearch.bind(this);
    this.loadRegions = this.loadRegions.bind(this);
    this.loadRegionsPolygons = this.loadRegionsPolygons.bind(this);
    this.addRegions = this.addRegions.bind(this);
    this.addNodo = this.addNodo.bind(this);
    this.addMunicipios = this.addMunicipios.bind(this);
    this.addZonas = this.addZonas.bind(this);
    this.logOut = this.logOut.bind(this);
    this.reset_layers = this.reset_layers.bind(this);
    this.forceOff = this.forceOff.bind(this);

    this.state = {
      logged: false,
      mapType: 1,
      showLTE: false,
      showFTTH: false,
      showAdquirida: false,
      showHFC: false,
      showSearchBoxNodo: false,
      showSearchBoxPoste: false,
      showSearchBoxCoordenadas: false,
      showSearch: false,
      showRegions: false,
      latC: 14.654011581568634,
      lonC: -90.68527221679688,
      dataLoaded: 0,
      lte: null,
      ftth: null,
      antenas: null,
      noConstruidas: null,
      sLat: null,
      sLon: null,
      sObservaciones: null,
      sNodo: null,
      sTipo: null,
      regions: null,
      region_polygons: null,
      nodos: [],
      regions_array: [],
      municipios_array: [],
      zonas_array: [],
      nodo_array: [],
      showInitialModal: true,
      fLat: null,
      fLon: null,
      fIcon: true,
      type: 0,
      compact: 0,
      force: 0,
      geoPer: "",
      zoom: false,
      name: ""
    };
  }

  forceOff() {
    this.setState({ force: 0 });
  }

  addNodo(nodo) {
    this.setState({ showAdquirida: false, showHFC: false, showLTE: false, showRegions: false, regions_array: [], municipios_array: [], zonas_array: [], nodo_array: nodo, zoom: false });
  }

  //Function to add regions to the array
  addRegions(region, op) {
    let regions_array = this.state.regions_array;

    // Check if the region already exists
    if (regions_array.indexOf(region) >= 0) {
      for (let i = 0; i < regions_array.length; i++) {
        if (regions_array[i] === region) {
          regions_array.splice(i, 1);
        }
      }
    } else {
      regions_array.push(region);
    }
    this.setState({ regions_array, zoom: true });
  }

  //Function to add municipios to the array
  addMunicipios(municipio) {
    let municipios_array = this.state.municipios_array;

    // Check if the region already exists
    if (municipios_array.indexOf(municipio) >= 0) {
      for (let i = 0; i < municipios_array.length; i++) {
        if (municipios_array[i] === municipio) {
          municipios_array.splice(i, 1);
        }
      }
    } else {
      municipios_array.push(municipio);
    }

    if (municipios_array.indexOf("GUATEMALA") < 0 && municipios_array.indexOf("MIXCO") < 0) {
      this.setState({ municipios_array, nodo_array: [], showRegions: !this.state.showRegions });
    } else {
      this.setState({ municipios_array, nodo_array: [] });
    }

  }

  //Function to add zonas to the array
  addZonas(zona) {
    let zonas_array = this.state.zonas_array;

    // Check if the region already exists
    if (zonas_array.indexOf(zona) >= 0) {
      for (let i = 0; i < zonas_array.length; i++) {
        if (zonas_array[i] === zona) {
          zonas_array.splice(i, 1);
        }
      }
    } else {
      zonas_array.push(zona);
    }
    this.setState({ zonas_array, showRegions: false });
  }

  //Function to change the logged state
  changeLogged(logged, data) {
    // console.log(data);
    this.setState({ logged, type: data.tipo, compact: data.compacto, dataLoaded: 0, name: data.nombre, force: data.force, sTipo: "ME" });
  }

  //Function to change the form lat and lon
  changeFCoordinates(fLat, fLon, fIcon) {
    this.setState({ fLat, fLon, fIcon });
  }

  // Function to change the map type 
  changeMapType(mapType) {
    this.setState({ mapType });
  }

  // Function to toggle LTE
  toggleLTE(op) {
    if (op === 1) {
      this.setState({ showAdquirida: false, showHFC: false, showLTE: true, showRegions: false, regions_array: [], municipios_array: [], zonas_array: [], nodo_array: [] });
    } else {
      this.setState({ showLTE: !this.state.showLTE });
    }
  }

  // Function to toggle FTTH
  toggleFTTH(op) {
    if (op === 1) {
      this.setState({ showAdquirida: false, showHFC: false, showLTE: false, showFTTH: true, showRegions: false, regions_array: [], municipios_array: [], zonas_array: [], nodo_array: [] });
    } else {
      this.setState({ showFTTH: !this.state.showFTTH });
    }
  }

  // Function to toggle Search nodo modal
  toggleSearchNodo() {
    this.setState({ showSearchBoxNodo: !this.state.showSearchBoxNodo });
  }

  // Function to toggle Search poste modal
  toggleSearchPoste() {
    this.setState({ showSearchBoxPoste: !this.state.showSearchBoxPoste });
  }

  // Function to toggle Search Coordenadas modal
  toggleSearchCoordenadas() {
    this.setState({ showSearchBoxCoordenadas: !this.state.showSearchBoxCoordenadas });
  }

  // Function to toggle Initial Modal
  toggleInitialModal() {
    this.setState({ showInitialModal: !this.state.showInitialModal });
  }

  // Function to toggle Search
  toggleSearch() {
    this.setState({ showSearch: !this.state.showSearch });
  }

  // Function to toggle Regions
  toggleRegions() {
    this.setState({ showRegions: !this.state.showRegions, regions_array: [], municipios_array: [], zonas_array: [] });
  }
  // Function to toggle Regions
  toggleRegionsMenu() {
    this.setState({ showRegions: !this.state.showRegions });
  }

  // Function to toggle Adquirida
  toggleAdquirida(op) {
    if (op === 1) {
      this.setState({ showAdquirida: true, showHFC: true, showLTE: false, showRegions: false, regions_array: [], municipios_array: [], zonas_array: [], nodo_array: [] });
    } else {
      this.setState({ showAdquirida: !this.state.showAdquirida });
    }
  }

  // Function to toggle HFC
  toggleHFC(op) {
    if (op === 1) {
      this.setState({ showAdquirida: true, showHFC: true, showLTE: false, showRegions: false, regions_array: [], municipios_array: [], zonas_array: [], nodo_array: [] });
    } else {
      this.setState({ showHFC: !this.state.showHFC });
    }
  }

  //Update data loaded
  updateLoaded() {
    this.setState({ dataLoaded: 2 });
  }

  // Get location from the GPS
  getLocation() {
    let t_ = this;
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(this.showPosition, function (error) {
        if (error.code === 1) {
          t_.setState({ showRegions: true, showInitialModal: false });
        }
      });
    }
  }
  showPosition(position) {
    this.setState({ latC: position.coords.latitude, lonC: position.coords.longitude, sTipo: "ME", sNodo: "Me" });
  }

  //We update the search parameters
  updateSearch(sLat, sLon, sObservaciones, sNodo, sTipo) {
    this.setState({ sLat, sLon, sObservaciones, sNodo, sTipo });
  }

  //Did mount
  componentDidMount() {
    this.getLocation();
    this.loadPolygons();
    let t_ = this;
    if (typeof navigator.permissions !== "undefined") {
      navigator.permissions.query({ name: 'geolocation' }).then(function (status) {
        if (status.state === "denied") {
          t_.setState({ showRegions: true, showInitialModal: false });
        }
      });
    }
  }

  reset_layers() {
    this.setState({ showAdquirida: false, showHFC: false, showLTE: false, regions_array: [], municipios_array: [], zonas_array: [] });
  }
  // Function to log out the user
  logOut() {
    this.setState({ type: 0, logged: false, showSearch: false, showRegions: false, showInitialModal: true });
    localStorage.removeItem("tigoID");
  }

  // We load the poligons
  loadPolygons() {
    let t_ = this;
    axios.post(url + "get_poly")
      .then(function (response) {
        t_.setState({ antenas: response.data.antenas, lte: response.data.lte, ftth: response.data.ftth, noConstruidas: response.data.noConstruidas });
        t_.loadRegions();
        t_.loadRegionsPolygons();
        t_.loadNodos();
      })
      .catch(function (error) {
        console.log(error);
      });

  }

  loadNodos() {
    let t_ = this;
    axios.post(url + "get_nodos")
      .then(function (response) {
        t_.setState({ nodos: response.data });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadRegions() {
    let t_ = this;
    axios.post(url + "get_regions")
      .then(function (response) {
        t_.setState({ regions: response.data });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadRegionsPolygons() {
    let t_ = this;
    axios.post(url + "get_regions_polygons")
      .then(function (response) {
        t_.setState({ region_polygons: response.data, dataLoaded: 1 });
      })
      .catch(function (error) {
        console.log(error);
      });
  }


  //Render function
  render() {
    let loading = "";

    if (this.state.dataLoaded === 0) {
      loading = (
        <div className="loading">
          <img src="images/loading.gif" alt="" />
        </div>
      );
    }

    return (
      <MuiThemeProvider theme={theme}>
        <React.Fragment>
          {loading}
          <CssBaseline />
          <Router>
            <div id="main">
              <Header
                url={url}
                type={this.state.type}
                isLoggedIn={this.state.logged}
                name={this.state.name}
                compact={this.state.compact}
                changeMapType={this.changeMapType}
                mapType={this.state.mapType}
                showSearchBoxNodo={this.state.showSearchBoxNodo}
                showSearchBoxPoste={this.state.showSearchBoxPoste}
                showSearchBoxCoordenadas={this.state.showSearchBoxCoordenadas}
                toggleLTE={this.toggleLTE}
                toggleFTTH={this.toggleFTTH}
                fLat={this.state.fLat}
                fLon={this.state.fLon}
                showLTE={this.state.showLTE}
                showFTTH={this.state.showFTTH}
                showSearch={this.state.showSearch}
                force={this.state.force}
                showRegions={this.state.showRegions}
                toggleAdquirida={this.toggleAdquirida}
                showAdquirida={this.state.showAdquirida}
                toggleHFC={this.toggleHFC}
                showHFC={this.state.showHFC}
                toggleSearch={this.toggleSearch}
                toggleRegions={this.toggleRegions}
                logOut={this.logOut}
                toggleSearchNodo={this.toggleSearchNodo}
                toggleSearchPoste={this.toggleSearchPoste}
                toggleSearchCoordenadas={this.toggleSearchCoordenadas}
                forceOff={this.forceOff}
              />
              {
                this.state.logged ? (
                  <React.Fragment>
                    <Route exact path="/"
                      render={(props) =>
                        <Landing {...props}
                          url={url}
                          isLoggedIn={this.state.logged}
                          changeLogged={this.changeLogged}
                          getLocation={this.getLocation} />} />
                    <Route path="/mapa"
                      render={(props) =>
                        <Mapa {...props}
                          url={url}
                          latC={this.state.latC}
                          lonC={this.state.lonC}
                          mapType={this.state.mapType}
                          showLTE={this.state.showLTE}
                          showFTTH={this.state.showFTTH}
                          showAdquirida={this.state.showAdquirida}
                          showHFC={this.state.showHFC}
                          showSearch={this.state.showSearch}
                          showRegions={this.state.showRegions}
                          showInitialModal={this.state.showInitialModal}
                          antenas={this.state.antenas}
                          regions_array={this.state.regions_array}
                          municipios_array={this.state.municipios_array}
                          zonas_array={this.state.zonas_array}
                          nodos={this.state.nodos}
                          nodo_array={this.state.nodo_array}
                          lte={this.state.lte}
                          ftth={this.state.ftth}
                          noConstruidas={this.state.noConstruidas}
                          dataLoaded={this.state.dataLoaded}
                          sLat={this.state.sLat}
                          sLon={this.state.sLon}
                          fLat={this.state.fLat}
                          fLon={this.state.fLon}
                          fIcon={this.state.fIcon}
                          zoom={this.state.zoom}
                          showSearchBoxNodo={this.state.showSearchBoxNodo}
                          showSearchBoxPoste={this.state.showSearchBoxPoste}
                          showSearchBoxCoordenadas={this.state.showSearchBoxCoordenadas}
                          geoPer={this.state.geoPer}
                          sObservaciones={this.state.sObservaciones}
                          sNodo={this.state.sNodo}
                          sTipo={this.state.sTipo}
                          region_polygons={this.state.region_polygons}
                          regions={this.state.regions}
                          updateLoaded={this.updateLoaded}
                          updateSearch={this.updateSearch}
                          toggleRegions={this.toggleRegions}
                          addRegions={this.addRegions}
                          addNodo={this.addNodo}
                          addMunicipios={this.addMunicipios}
                          addZonas={this.addZonas}
                          toggleInitialModal={this.toggleInitialModal}
                          getLocation={this.getLocation}
                          changeFCoordinates={this.changeFCoordinates}
                          toggleSearch={this.toggleSearch}
                          toggleLTE={this.toggleLTE}
                          toggleAdquirida={this.toggleAdquirida}
                          toggleHFC={this.toggleHFC}
                          reset_layers={this.reset_layers}
                          toggleSearchNodo={this.toggleSearchNodo}
                          toggleSearchPoste={this.toggleSearchPoste}
                          toggleSearchCoordenadas={this.toggleSearchCoordenadas}
                        />
                      } />
                  </React.Fragment>
                ) : (
                  <Route path="/"
                    render={(props) => <Landing {...props} url={url} isLoggedIn={this.state.logged} changeLogged={this.changeLogged} getLocation={this.getLocation} />} />
                )
              }

            </div>
          </Router>
        </React.Fragment>
      </MuiThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js